import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/experience-platform-apis/experience-platform-apis/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Hero = makeShortcode("Hero");
const AnnouncementBlock = makeShortcode("AnnouncementBlock");
const Resources = makeShortcode("Resources");
const DiscoverBlock = makeShortcode("DiscoverBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <Hero slots="heading, text" mdxType="Hero" />
    <h1 {...{
      "id": "adobe-experience-platform-apis"
    }}>{`Adobe Experience Platform APIs`}</h1>
    <p>{`Experience Platform services provide RESTful APIs that allow you to programmatically perform key operations in your applications.`}</p>
    <AnnouncementBlock slots="heading, text, button" mdxType="AnnouncementBlock" />
    <h3 {...{
      "id": "use-the-interactive-api-environment"
    }}>{`Use the interactive API environment`}</h3>
    <p>{`You can now interact with the Experience Platform API endpoints directly from the API reference pages. Get your `}<a parentName="p" {...{
        "href": "https://www.adobe.com/go/platform-api-get-credentials-en"
      }}>{`authentication credentials`}</a>{` and use the `}<strong parentName="p">{`Try it`}</strong>{` functionality in the right rail.`}</p>
    <p><a parentName="p" {...{
        "href": "https://www.adobe.com/go/platform-api-try-it-en"
      }}>{`Learn more`}</a></p>
    <Resources slots="heading, links" mdxType="Resources" />
    <h4 {...{
      "id": "resources"
    }}>{`Resources`}</h4>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "https://experienceleague.adobe.com/docs/experience-platform.html"
        }}>{`Experience Platform documentation`}</a></li>
    </ul>
    <h2 {...{
      "id": "overview"
    }}>{`Overview`}</h2>
    <p>{`Adobe Experience Platform is developed with an "API first" philosophy. Using Platform APIs, you can programmatically perform basic CRUD (Create, Read, Update, Delete) operations against data, such as configuring computed attributes, accessing data/entities, exporting data, deleting unneeded data or batches, and more.`}</p>
    <p>{`The API references listed below serve as high-level overviews of the available endpoints provided by each Platform API. For more detailed information on the use of these APIs, please refer to the documentation linked from within each reference.`}</p>
    <h2 {...{
      "id": "discover"
    }}>{`Discover`}</h2>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "get-started"
    }}>{`Get Started`}</h3>
    <p><a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/landing/platform-apis/api-authentication.html"
      }}>{`Authenticate and access Experience Platform APIs`}</a></p>
    <p>{`Follow this tutorial to gather the required authentication credentials for all Experience Platform APIs (except for the Privacy Service API and Reactor API).`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/privacy/api/getting-started.html"
      }}>{`Authenticate and access the Privacy Service API`}</a></p>
    <p>{`Follow this tutorial to gather the required authentication credentials for the Privacy Service API.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "https://experienceleague.adobe.com/docs/experience-platform/tags/api/getting-started.html"
      }}>{`Authenticate and access the Reactor API`}</a></p>
    <p>{`Follow this tutorial to gather the required authentication credentials for the Reactor API.`}</p>
    <DiscoverBlock slots="heading, link, text" mdxType="DiscoverBlock" />
    <h3 {...{
      "id": "api-references"
    }}>{`API References`}</h3>
    <p><a parentName="p" {...{
        "href": "references/access-control.md"
      }}>{`Access Control API`}</a></p>
    <p>{`View available and active user permissions.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/audit-query.md"
      }}>{`Audit Query API`}</a></p>
    <p>{`View audit logs on Platform activities.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/batch-ingestion.md"
      }}>{`Batch Ingestion API`}</a></p>
    <p>{`Bring data into Platform through batch ingestion.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/catalog.md"
      }}>{`Catalog Service API`}</a></p>
    <p>{`Manage metadata for datasets and batches.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/data-access.md"
      }}>{`Data Access API`}</a></p>
    <p>{`Access and download ingested dataset files.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/data-distiller-auth.md"
      }}>{`Data Distiller Authorization API`}</a></p>
    <p>{`Manage and enforce IP-based access restrictions for secure data access to Query Service sandboxes.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/data-hygiene.md"
      }}>{`Data Hygiene API`}</a></p>
    <p>{`Schedule expiration dates for datasets and programmatically correct or delete your customers' stored personal data.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/data-prep.md"
      }}>{`Data Prep API`}</a></p>
    <p>{`Map, transform, and validate data to and from Experience Data Model (XDM).`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/dataset-service.md"
      }}>{`Dataset Service API`}</a></p>
    <p>{`Manage usage labels for existing datasets within the Data Lake.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/destination-authoring.md"
      }}>{`Destination Authoring API (Destination SDK)`}</a></p>
    <p>{`Author a destination in the Experience Platform catalog.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/flow-service.md"
      }}>{`Flow Service API - Sources`}</a></p>
    <p>{`Use the Flow Service API to ingest data from external sources into Experience Platform.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/destinations.md"
      }}>{`Flow Service API - Destinations`}</a></p>
    <p>{`Use the Flow Service API to connect to destinations and activate data.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/identity-service.md"
      }}>{`Identity Service API`}</a></p>
    <p>{`Manage identities, namespaces, and clusters linked to the Identity Graph.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/mtls-service.md"
      }}>{`MTLS Service API`}</a></p>
    <p>{`Securely retrieve and verify the public certificates issued by Adobe.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/observability-insights.md"
      }}>{`Observability Insights API`}</a></p>
    <p>{`View metrics on various Platform activities.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/policy-service.md"
      }}>{`Policy Service API`}</a></p>
    <p>{`Manage data usage labels and policies.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/privacy-service.md"
      }}>{`Privacy Service API`}</a></p>
    <p>{`Manage customer requests to access and delete their personal data.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/query-service.md"
      }}>{`Query Service API`}</a></p>
    <p>{`Use standard SQL to query data in Experience Platform.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/reactor.md"
      }}>{`Reactor API`}</a></p>
    <p>{`Manage extensions, rules, and other resources related to tags.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/profile.md"
      }}>{`Real-time Customer Profile API`}</a></p>
    <p>{`Manage merge policies and other Profile-related resources.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/sandbox.md"
      }}>{`Sandbox API`}</a></p>
    <p>{`Manage sandboxes for your organization.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/schema-registry.md"
      }}>{`Schema Registry API`}</a></p>
    <p>{`Manage Experience Data Model (XDM) schemas.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/segmentation.md"
      }}>{`Segmentation Service API`}</a></p>
    <p>{`Build audiences from your Real-Time Customer Profile data using Adobe Experience Platform generated segment definitions or external sources.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/sensei-machine-learning.md"
      }}>{`Sensei Machine Learning API`}</a></p>
    <p>{`Manage engines, models, and other resources related to Data Science Workspace.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/streaming-ingestion.md"
      }}>{`Streaming Ingestion API`}</a></p>
    <p>{`Bring data in to Platform through streaming ingestion.`}</p>
    <DiscoverBlock slots="link, text" mdxType="DiscoverBlock" />
    <p><a parentName="p" {...{
        "href": "references/unified-tags.md"
      }}>{`Unified Tags API`}</a></p>
    <p>{`Better organize your business objects by using folders, tags, and tag categories.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      